

import "./About.css";

export default function About() {
  return (
    <section id="about" className="section">
      <div className="container">
        <div className="sectionHeader">
          <h2 className="sectionTitle">About</h2>
          <p className="sectionSubtitle">
            Frontend Developer (React) | IT Support & QA Background

          </p>
        </div>

        <div className="about">
          <div className="about__media">
            <img
              className="about__img"
              src="/assets/profile.jpg"
              alt="R. Issouf Zabre profile"
              loading="lazy"
            />
          </div>

          <div className="about__content">
            <p>
             Detail-oriented IT Technician and Software Developer with 4+ years of experience delivering hardware, software, AV, and systems support in fast-paced environments. Proven ability to design, build, and maintain production-ready React applications supporting real business operations. Skilled in troubleshooting, QA testing, system optimization, and user training with a strong customer-service mindset. Adept at bridging technical support and software development to deliver scalable, reliable, user-focused solutions.
            </p>

            <p>
              I’m process-driven and organized, with strong experience in inventory management, device imaging and
              redeployment workflows, onboarding/offboarding, and providing user support while applying
              least-privilege access practices.
            </p>

            <div className="about__actions">
              <a className="btn btn--primary" href="#contact">
                Contact Me
              </a>

              {/* Put your PDF resume into public/assets/Resume-R-Issouf-Zabre.pdf */}
              {/* <a
                className="btn btn--ghost"
                href="/assets/Resume-R-Issouf-Zabre.pdf"
                target="_blank"
                rel="noreferrer"
              >
                View Resume
              </a> */}
            </div>

            <div className="about__highlights">
              <div className="card">
                <div className="card__title">Core Strengths</div>
                <ul className="list">
                  <li>End-user support (Windows/macOS), troubleshooting & ticketing</li>
                  <li>Google Workspace administration & access control</li>
                  <li>Device lifecycle: imaging, configuration, redeployments</li>
                  <li>Inventory, loaners, preventative maintenance</li>
                </ul>
              </div>

              <div className="card">
                <div className="card__title">Tools & Platforms</div>
                <ul className="list">
                   <li>React, JavaScript / TypeScript</li>
                  <li>Node.js, Express,Firebase, CI basics</li>
                   <li>Docker, Git, SQL, basic automation (n8n)</li>
                 <li>Slack, Okta, Zoom, JIRA</li>
                  <li>Slack, Okta, Zoom, JIRA, QA Touch</li>
                  <li>Device imaging / MDM workflows, onboarding/offboarding</li>
                </ul>
              </div>

              <div className="card">
                <div className="card__title">Languages</div>
                <ul className="list">
                  <li>English — Professional Fluency</li>
                  <li>French — Professional Fluency</li>
                  <li>Mooré — Professional Fluency</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
